'use client';
import { rgba } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const containerStyles = (theme)=>_extends({
        padding: theme.fn.space('2.5s 5s'),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%',
        borderColor: 'transparent'
    }, theme.fn.transition({
        props: [
            'transform',
            'background',
            'border-bottom'
        ],
        duration: '0.5s',
        fn: 'ease'
    }), {
        '&[data-show=true]': {
            transform: 'translateY(0)'
        },
        '&[data-show=false]': {
            transform: 'translateY(-100%)'
        },
        '&[data-background=true]': _extends({
            backdropFilter: 'blur(20px)',
            background: rgba(theme.palette.tabsnav.background, 0.85)
        }, theme.fn.border({
            pos: [
                'bottom'
            ],
            width: 1,
            color: theme.palette.border.element,
            style: 'solid'
        }))
    });

export { containerStyles };
//# sourceMappingURL=Header.styles.js.map
